import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import IntervenantsPanel from './IntervenantsPanel';

interface Props {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  prestNumero: string | null;
  clientNom?: string;
}

export default function IntervenantsModal({ open, onOpenChange, prestNumero, clientNom }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl bg-slate-900 border-slate-800 text-slate-100">
        <DialogHeader>
          <DialogTitle className="text-slate-200">
            Intervenants — {prestNumero || '—'}
            {clientNom && <span className="text-slate-500 text-sm font-normal ml-2">· {clientNom}</span>}
          </DialogTitle>
        </DialogHeader>
        {prestNumero ? (
          <IntervenantsPanel prestNumero={prestNumero} />
        ) : (
          <div className="text-sm text-slate-400 italic">Numéro de prestation manquant.</div>
        )}
      </DialogContent>
    </Dialog>
  );
}
